import React from 'react';
import { 
    Card, 
    Tooltip, 
    ButtonToolbar, 
    OverlayTrigger, 
    Badge 
} from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import moment from 'moment';

import styles from './index.module.scss';

function Evento({
    dados,
    modo='cadastro', // cadastro, automatico
    excluir,
    alterar
}){
    return (
        <Card className={[styles.evento, 'shodow-sm', (modo === 'automatico') && 'bg-light'].join(' ')}>
            <Card.Body className='pb-2'>
                {modo === 'cadastro' &&
                    <>
                        {dados.concluido === 'N' ?
                            <small>{moment(dados.data_programada).format('DD/MM/YYYY')}</small>
                        :
                            <>
                                <small className='mr-1'>{moment(dados.data_concluido).format('DD/MM/YYYY')}</small>
                                <Badge variant='success'>
                                    Concluido
                                </Badge>
                            </>
                        }
                        <hr className='mt-1' />
                    </>
                }
                <p className='mb-0'>{dados.descricao}</p>
                <div className={[styles.opcoes, 'p-1'].join(' ')}>
                    {modo === 'cadastro' &&
                        <ButtonToolbar>
                            <OverlayTrigger
                                placement='top'
                                overlay={<Tooltip>Editar</Tooltip>}
                            >
                                <button
                                    onClick={alterar}
                                    className='rounded-circle'
                                >
                                    <FontAwesomeIcon className="icone" icon={["fas", 'pencil-alt']} />
                                </button>
                            </OverlayTrigger>
                        </ButtonToolbar>
                    }

                    {(modo === 'automatico' || dados.id === null) &&
                        <ButtonToolbar>
                            <OverlayTrigger
                                placement='top'
                                overlay={<Tooltip>Excluir</Tooltip>}
                            >
                                <button
                                    onClick={excluir}
                                    className='rounded-circle'
                                >
                                    <FontAwesomeIcon className="icone" icon={["fas", 'trash']} />
                                </button>
                            </OverlayTrigger>
                        </ButtonToolbar>
                    }
                </div>
                {dados.recorrente === "S" && !dados?.recorrente_pai && <div
                    className='d-flex w-100 justify-content-end'
                >
                    <Badge variant='info' style={{ fontSize: 11 }}>
                        Recorrente
                    </Badge>
                </div>}
            </Card.Body>
        </Card>
    )
}

export default Evento;